import React, { useEffect, useState } from 'react';
import './Home.css';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    LabelList,
} from "recharts";
import iPosto from '../interfaces/iPosto';

import { useSelector } from 'react-redux';
import { RootState } from '../store';

const cores = [
    '#0B3D91', '#1E90FF', '#00BFFF', '#4682B4', '#5F9EA0',
    '#6495ED', '#4169E1', '#0000CD', '#00688B', '#008B8B',
    '#20B2AA', '#48D1CC', '#40E0D0', '#00CED1', '#00FA9A',
    '#00FF7F', '#32CD32', '#2E8B57', '#3CB371', '#66CDAA',
    '#8FBC8F', '#228B22', '#008000', '#006400', '#2F4F4F',
    '#556B2F', '#6B8E23', '#7FFF00', '#7CFC00', '#ADFF2F'
];

const Home = ({ setCurrentPage }: { setCurrentPage: Function; }) => {

    const apiUrl = process.env.REACT_APP_API_URL;

    const [postosList, setPostosList] = useState<any[]>([]);

    const [dataG1, setDataG1] = useState<any[]>([]);

    const { bootStrapColor } = useSelector((state: RootState) => state.config);

    const [searchInput, setSearchInput] = useState({
        g1_ano: getAnoAtual()
    });

    function getAnoAtual(): number {
        return new Date().getFullYear();
    }

    const { g1_ano } = searchInput;

    const useElementWidth = () => {
        const [elementWidth, setElementWidth] = useState(0);

        useEffect(() => {
            const element = document.getElementById('graficontainer');

            const handleResize = () => {
                if (element) {
                    setElementWidth(element.offsetWidth);
                }
            };

            handleResize();

            window.addEventListener('resize', handleResize);

            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }, []);

        return elementWidth;
    };

    const handleSearchInputChanges = (element: any) => {
        setSearchInput({ ...searchInput, [element.target.name]: element.target.value });
    };

    const submitSearch1 = async () => {
        try {
            const response = await fetch(`${apiUrl}/grafico/1/${searchInput.g1_ano}`);
            const jsonResponse = await response.json();
            setDataG1(jsonResponse);
        } catch (err: any) {
            console.error(err.message);
        }
    };

    const handleInit = async () => {
        try {
            const response = await fetch(`${apiUrl}/all-postos-com-chuva-hoje`);

            if (!response.ok) {
                throw new Error(`Erro ${response.status}: ${response.statusText}`);
            }

            const jsonPostosList: iPosto[] = await response.json();
            setPostosList(jsonPostosList);
            await submitSearch1();
        } catch (error) {
            console.error("Erro ao buscar os postos com chuva:", error);
        }
    };



    useEffect(() => {
        setCurrentPage(window.location.pathname);
        handleInit();
    }, []);

    return (
        <>
            <div className="computador-view home-container p-4 d-flex justify-content-between ms-5 me-5 overflow-hidden">
                <div className="card h-100 mb-5 me-3" style={{ minWidth: "250px" }}>
                    <h5 className="card-header text-center">Postos</h5>
                    <div className="card-body overflow-scroll">
                        <table className="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th scope="col"></th>
                                    <th scope="col">Chuva</th>
                                    <th scope="col">Qtd</th>
                                    <th scope="col">Nome</th>

                                </tr>
                            </thead>
                            <tbody>
                                {postosList.map((posto, index) => {
                                    return (<tr role='button' key={posto.posto_id}>
                                        <th scope="row">{index + 1}</th>
                                        <td className='text-nowrap text-center'>{Number(posto.quantidade_chuva) > 0 ? <i className="bi bi-check-circle text-success"></i> : <i className="bi bi-x-circle text-danger"></i>}</td>
                                        <td className='text-nowrap'>{posto.quantidade_chuva}mm</td>
                                        <td className='text-nowrap'>{posto.posto_nome}</td>
                                    </tr>);
                                })}
                            </tbody>
                        </table>
                    </div>
                </div >
                <div className="w-100">

                    <div className="card w-90 mb-3">
                        <h5 className="card-header text-center">Previsão</h5>
                        <div className="card-body d-flex flex-column">
                            <iframe title='m' width="100%" height="187" src="https://embed.windy.com/embed.html?type=forecast&location=coordinates&detail=true&detailLat=-7.092728065840021&detailLon=-35.2269664497461&metricTemp=°C&metricRain=mm&metricWind=m/s" frameBorder={0}></iframe>
                        </div>
                    </div >

                    <div className="d-flex w-100">
                        <div className="card mb-3 overflow-hidden h-100" style={{ width: "100%" }}>
                            <div className="card-header css-app-cinza-claro d-flex justify-content-between">
                                <div>
                                    <h5 className='p-0 m-0 pe-5'>Comparativo pluviométrico de postos</h5>
                                    <h5 className='p-0 m-0 pt-2 fw-lighter'>Ano {searchInput.g1_ano}</h5>
                                </div>
                                <div className='d-flex align-items-center'>
                                    <div className="input-group pe-2">
                                        <span className={`input-group-text bg-${bootStrapColor}`} id="inputGroup-ano">Ano</span>
                                        <input type="number" min={0} className="form-control" aria-label="ano" aria-describedby="inputGroup-ano" name='g1_ano' value={g1_ano} onChange={element => handleSearchInputChanges(element)} />
                                    </div>
                                    <button className='btn btn-primary' disabled={!searchInput.g1_ano || Number(searchInput.g1_ano) <= 0} onClick={submitSearch1}>Buscar</button>
                                </div>
                            </div>
                            <div className="card-body d-flex flex-wrap justify-content-center" id='graficontainer'>
                                <BarChart
                                    height={dataG1.length !== 0 ? 400 : 0}
                                    width={useElementWidth() - 30}
                                    data={dataG1}
                                    margin={{
                                        top: 30,
                                        right: 30,
                                        left: 20,
                                        bottom: 5,
                                    }}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    {postosList.map((element, index) => <Bar key={postosList[index].posto_id} dataKey={postosList[index].posto_nome} fill={cores[index] || 'black'}><LabelList dataKey={element.posto_nome} position="top" /></Bar>)}
                                </BarChart>
                                {dataG1.length === 0 ? <h5>Sem registros</h5> : null}
                            </div >
                        </div >

                        <div className="card ms-3 mb-3" style={{ width: "100%" }}>
                            <div className="card-header">
                                <h5 className="text-center">
                                    Mapa
                                </h5>
                            </div>
                            <div className="card-body d-flex p-0" style={{}}>
                                <iframe
                                    src="https://www.meteoblue.com/pt/tempo/mapas/widget?windAnimation=0&windAnimation=1&gust=0&gust=1&satellite=0&satellite=1&cloudsAndPrecipitation=0&cloudsAndPrecipitation=1&temperature=0&temperature=1&sunshine=0&sunshine=1&extremeForecastIndex=0&extremeForecastIndex=1&geoloc=detect&tempunit=C&windunit=km%252Fh&lengthunit=metric&zoom=5&autowidth=auto"
                                    sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox"
                                    title='Mapa' style={{ width: "100%" }}>
                                </iframe>
                            </div>
                        </div >
                    </div>

                    <div className="card">
                        <div className="card-header">
                            <h5 className="text-center">
                                Previsão do tempo
                            </h5>
                        </div>
                        <div className="card-body">
                            <div className="div4 d-flex">
                                <div className="card-body p-1">
                                    <iframe width="100%" height="100%" title='TopLeft'
                                        src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=km/h&zoom=9&overlay=wind&product=ecmwf&level=surface&lat=-7.338&lon=-35.228&detailLat=-7.094&detailLon=-35.228&detail=true">
                                    </iframe>
                                </div>
                                <div className="card-body p-1">
                                    <iframe width="100%" height="100%" title='TopRight'
                                        src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=km/h&zoom=7&overlay=satellite&product=satellite&level=surface&lat=-7.26&lon=-35.389&detailLat=-7.094&detailLon=-35.228&marker=true">
                                    </iframe>
                                </div>
                                <div className="card-body p-1">
                                    <iframe width="100%" height="100%" title='BotLeft'
                                        src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=km/h&zoom=9&overlay=temp&product=ecmwf&level=surface&lat=-7.135&lon=-35.199">
                                    </iframe>
                                </div>
                                <div className="card-body p-1">
                                    <iframe width="100%" height="100%" title='BotRight'
                                        src="https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=mm&metricTemp=°C&metricWind=km/h&zoom=9&overlay=radar&product=radar&level=surface&lat=-7.135&lon=-35.199">
                                    </iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="celular-view home-container p-4 d-flex justify-content-between ms-3 me-3 overflow-hidden">

                <div className="w-100">

                    <div className="card w-90 mb-3">
                        <h5 className="card-header text-center">Previsão</h5>
                        <div className="card-body d-flex flex-column">
                            <iframe title='m' width="100%" height="187" src="https://embed.windy.com/embed.html?type=forecast&location=coordinates&detail=true&detailLat=-7.092728065840021&detailLon=-35.2269664497461&metricTemp=°C&metricRain=mm&metricWind=m/s" frameBorder={0}></iframe>
                        </div>
                    </div >

                    <div className="card mb-3">
                        <h5 className="card-header text-center">Postos</h5>
                        <div className="card-body overflow-scroll">
                            <table className="table table-striped table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col">Chuva</th>
                                        <th scope="col">Qtd</th>
                                        <th scope="col">Nome</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {postosList.map((posto, index) => {
                                        return (<tr role='button' key={posto.posto_id}>
                                            <th scope="row">{index + 1}</th>
                                            <td className='text-nowrap text-center'>{Number(posto.quantidade_chuva) > 0 ? <i className="bi bi-check-circle text-success"></i> : <i className="bi bi-x-circle text-danger"></i>}</td>
                                            <td className='text-nowrap'>{posto.quantidade_chuva}mm</td>
                                            <td className='text-nowrap'>{posto.posto_nome}</td>
                                        </tr>);
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div >

                    <div className="card  mb-3" style={{ width: "100%" }}>
                        <div className="card-header">
                            <h5 className="text-center">
                                Mapa
                            </h5>
                        </div>
                        <div className="card-body d-flex p-0" style={{ height: "850px" }}>
                            <iframe
                                src="https://www.meteoblue.com/pt/tempo/mapas/widget?windAnimation=0&windAnimation=1&gust=0&gust=1&satellite=0&satellite=1&cloudsAndPrecipitation=0&cloudsAndPrecipitation=1&temperature=0&temperature=1&sunshine=0&sunshine=1&extremeForecastIndex=0&extremeForecastIndex=1&geoloc=detect&tempunit=C&windunit=km%252Fh&lengthunit=metric&zoom=5&autowidth=auto"
                                sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox"
                                title='Mapa' style={{ width: "100%" }}>
                            </iframe>
                        </div>
                    </div >

                </div>
            </div>
        </>
    );
};

export default Home;
